import type React from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Dropdown, DropdownButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";
import { LANGUAGES } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/components/LanguageDropdown/constants";
import {
    StyledDropdownContainer,
    StyledDropdownItem,
} from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/components/LanguageDropdown/styles";
import { WithTitleContainer } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/components/WithTitleContainer/WithTitleContainer";
import type { LanguageOption } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/types";
import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";

const DROPDOWN_ID = "si-agent-knowledge-base-language-dd";
const DROPDOWN_POPUP_HEIGHT = 44 * 4;

type Props = {
    value: string | null;
    onChange: (value: string) => void;
    dataAutomation?: string;
};

export const LanguageDropdown: React.FC<Props> = ({ value, onChange, dataAutomation }) => {
    const selectedIds = value ? { [value]: true } : {};

    const handleSelect = (option: LanguageOption) => {
        AIAgentTrackingService.kb.trackLanguageSelect(option.text);
        onChange(option.text);
    };

    const renderDDButton = () => {
        return (
            <StyledBaseDropdownButtonWrap buttonTextColor={colorsPalettes.carbon[400]}>
                <DropdownButton>{value}</DropdownButton>
            </StyledBaseDropdownButtonWrap>
        );
    };

    const renderOptions = () => {
        return LANGUAGES.map(({ id, text }) => (
            <StyledDropdownItem
                key={id}
                id={id}
                text={text}
            >
                {text}
            </StyledDropdownItem>
        ));
    };

    return (
        <WithTitleContainer
            title={translate("si.agent_knowledge_base.modal.language.title")}
            dataAutomation={dataAutomation}
        >
            <StyledDropdownContainer id={DROPDOWN_ID}>
                <Dropdown
                    appendTo={`#${DROPDOWN_ID}`}
                    selectedIds={selectedIds}
                    onClick={handleSelect}
                    searchPlaceHolder={translate("si.agent_knowledge_base.modal.language.search")}
                    dropdownPopupHeight={DROPDOWN_POPUP_HEIGHT}
                    dropdownPopupPlacement="bottom-left"
                    autoPlacement={false}
                    hasSearch
                >
                    {[renderDDButton(), ...renderOptions()]}
                </Dropdown>
            </StyledDropdownContainer>
        </WithTitleContainer>
    );
};
